// extracted by mini-css-extract-plugin
module.exports = {"comp":"Bundles_comp__Q1cbU"};